export default "__VITE_ASSET__DFKK0FTP__"